import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	openTooltip: {
		id: 'native-issue-table.common.issue-cells.issue-summary.open-issue-link.open-tooltip',
		defaultMessage: 'Select work item',
		description: 'Tooltip message shown for the link to select a work item.',
	},
	openLabel: {
		id: 'native-issue-table.common.issue-cells.issue-summary.open-issue-link.open-label',
		defaultMessage: 'Select work item {issueKey}',
		description: 'Aria-label shown for the link to select a work item.',
	},
	openTooltipNew: {
		id: 'native-issue-table.common.issue-cells.issue-summary.open-issue-link.open-tooltip-new',
		defaultMessage: 'Open work item',
		description: 'Tooltip message shown for the link to open a work item.',
	},
	openLabelNew: {
		id: 'native-issue-table.common.issue-cells.issue-summary.open-issue-link.open-label-new',
		defaultMessage: 'Open work item {issueKey}',
		description: 'Aria-label shown for the link to open a work item.',
	},
});
